// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__SE5xh"};